import React from "react";
import { FaLinkedin, FaFacebook } from "react-icons/fa";
import {
  FooterContainer,
  FooterContent,
  FooterColumn,
  FooterHeading,
  FooterText,
  ContactLink,
  SocialLinks,
  DisabledLink,
  Copyright,
} from "./Footer.styles";
import { Link } from "react-router-dom";

const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <FooterContent>
        {/* Company Column */}
        <FooterColumn>
          <FooterHeading>Q3Learners</FooterHeading>
          <FooterText>
            Q3 Learners,LLC is an immersive learning platform designed to bridge the gap 
            between theory and real-world application. Gain hands-on experience 
            through mentor-led, project-based learning.
          </FooterText>
          <ContactLink href="mailto:support@q3learners.com">
            support@q3learners.com
          </ContactLink>
          <SocialLinks>
            <a href="https://www.linkedin.com/company/q3learners" target="_blank" rel="noopener noreferrer">
              <FaLinkedin size={18} />
            </a>
            <a href="https://www.facebook.com/profile.php?id=61572591000750" target="_blank" rel="noopener noreferrer">
              <FaFacebook size={18} />
            </a>
          </SocialLinks>
        </FooterColumn>

        {/* Platform Column */}
        <FooterColumn>
          <FooterHeading>Platform</FooterHeading>
          <ul>
            <li><DisabledLink aria-disabled="true">Courses</DisabledLink></li>
            <li><DisabledLink aria-disabled="true">Projects</DisabledLink></li>
            <li><DisabledLink aria-disabled="true">Mentorship</DisabledLink></li>
            <li><DisabledLink aria-disabled="true">Blog</DisabledLink></li>
          </ul>
        </FooterColumn>

        {/* Resources Column */}
        <FooterColumn>
          <FooterHeading>Resources</FooterHeading>
          <ul>
            <li><DisabledLink aria-disabled="true">Learning Path</DisabledLink></li>
            <li><DisabledLink aria-disabled="true">Success Stories</DisabledLink></li>
            <li><DisabledLink aria-disabled="true">FAQ</DisabledLink></li>
            <li><DisabledLink aria-disabled="true">Documentation</DisabledLink></li>
          </ul>
        </FooterColumn>

        {/* Legal Column */}
        <FooterColumn>
          <FooterHeading>Legal</FooterHeading>
          <ul>
            <li><Link to="/privacy">Privacy Policy</Link></li>
            <li><DisabledLink aria-disabled="true">Terms of Service</DisabledLink></li>
            <li><DisabledLink aria-disabled="true">Cookie Policy</DisabledLink></li>
            <li><DisabledLink aria-disabled="true">Accessibility</DisabledLink></li>
          </ul>
        </FooterColumn>
      </FooterContent>

      <Copyright>
        © {new Date().getFullYear()} Q3Learners. All rights reserved.
      </Copyright>
    </FooterContainer>
  );
};

export default Footer;
